module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921025649_T.cea4e910.jpg";